/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitalApesCustomsController } from "../OrbitalApesCustomsController";

export class OrbitalApesCustomsController__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _mintToken: string,
    _mintContract: string,
    _price: BigNumberish,
    _max: BigNumberish,
    overrides?: Overrides
  ): Promise<OrbitalApesCustomsController> {
    return super.deploy(
      _mintToken,
      _mintContract,
      _price,
      _max,
      overrides || {}
    ) as Promise<OrbitalApesCustomsController>;
  }
  getDeployTransaction(
    _mintToken: string,
    _mintContract: string,
    _price: BigNumberish,
    _max: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mintToken,
      _mintContract,
      _price,
      _max,
      overrides || {}
    );
  }
  attach(address: string): OrbitalApesCustomsController {
    return super.attach(address) as OrbitalApesCustomsController;
  }
  connect(signer: Signer): OrbitalApesCustomsController__factory {
    return super.connect(signer) as OrbitalApesCustomsController__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitalApesCustomsController {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as OrbitalApesCustomsController;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mintContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_max",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "priceUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "max",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintContract",
        type: "address",
      },
    ],
    name: "setMintContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_max",
        type: "uint256",
      },
    ],
    name: "setMintToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_mintToken",
        type: "address",
      },
    ],
    name: "setMintToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b50604051620010c1380380620010c18339810160408190526200003491620001ff565b620000416000336200007d565b600380546001600160a01b039485166001600160a01b031991821617909155600280549590941694169390931790915560045560055562000246565b6200008982826200008d565b5050565b620000a48282620000d060201b620006261760201c565b6000828152600160209081526040909120620000cb918390620006aa62000170821b17901c565b505050565b6000828152602081815260408083206001600160a01b038516845290915290205460ff1662000089576000828152602081815260408083206001600160a01b03851684529091529020805460ff191660011790556200012c3390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b600062000187836001600160a01b03841662000190565b90505b92915050565b6000818152600183016020526040812054620001d9575081546001818101845560008481526020808220909301849055845484825282860190935260409020919091556200018a565b5060006200018a565b80516001600160a01b0381168114620001fa57600080fd5b919050565b6000806000806080858703121562000215578384fd5b6200022085620001e2565b93506200023060208601620001e2565b6040860151606090960151949790965092505050565b610e6b80620002566000396000f3fe608060405234801561001057600080fd5b50600436106101165760003560e01c80636ac5db19116100a2578063a035b1fe11610071578063a035b1fe14610237578063a217fddf14610240578063ca15c87314610248578063d0b6b6db1461025b578063d547741f1461026e57610116565b80636ac5db19146101f55780639010d07c146101fe57806391b7f5ed1461021157806391d148541461022457610116565b8063248a9ca3116100e9578063248a9ca31461018b5780632f2ff15d146101bc57806336568abe146101cf5780634a13e91d146101e25780635fb64a6a146101e257610116565b806301ffc9a71461011b578063027f401e146101435780631249c58b146101585780632004ffd914610160575b600080fd5b61012e610129366004610c54565b610281565b60405190151581526020015b60405180910390f35b610156610151366004610bf0565b6102ae565b005b6101566102e3565b600254610173906001600160a01b031681565b6040516001600160a01b03909116815260200161013a565b6101ae610199366004610bf0565b60009081526020819052604090206001015490565b60405190815260200161013a565b6101566101ca366004610c08565b61044d565b6101566101dd366004610c08565b610477565b6101566101f0366004610bd6565b6104f5565b6101ae60055481565b61017361020c366004610c33565b61053e565b61015661021f366004610bf0565b61055f565b61012e610232366004610c08565b6105c1565b6101ae60045481565b6101ae600081565b6101ae610256366004610bf0565b6105ea565b600354610173906001600160a01b031681565b61015661027c366004610c08565b610601565b60006001600160e01b03198216635a05180f60e01b14806102a657506102a6826106bf565b90505b919050565b6102b9600033610232565b6102de5760405162461bcd60e51b81526004016102d590610d3c565b60405180910390fd5b600555565b600554600360009054906101000a90046001600160a01b03166001600160a01b03166318160ddd6040518163ffffffff1660e01b815260040160206040518083038186803b15801561033457600080fd5b505afa158015610348573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061036c9190610c7c565b1061037657600080fd5b6002546004805460405163079cc67960e41b8152339281019290925260248201526001600160a01b03909116906379cc679090604401600060405180830381600087803b1580156103c657600080fd5b505af11580156103da573d6000803e3d6000fd5b50506003546001600160a01b03169150636a6278429050336040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401600060405180830381600087803b15801561043357600080fd5b505af1158015610447573d6000803e3d6000fd5b50505050565b600082815260208190526040902060010154610468816106f4565b6104728383610701565b505050565b6001600160a01b03811633146104e75760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b60648201526084016102d5565b6104f18282610723565b5050565b610500600033610232565b61051c5760405162461bcd60e51b81526004016102d590610d3c565b600280546001600160a01b0319166001600160a01b0392909216919091179055565b60008281526001602052604081206105569083610745565b90505b92915050565b61056a600033610232565b6105865760405162461bcd60e51b81526004016102d590610d3c565b60048190556040518181527fba183368bdfb67a6c0e60b2a8666381c33610509a956ac629eaae3874e0063e59060200160405180910390a150565b6000918252602082815260408084206001600160a01b0393909316845291905290205460ff1690565b60008181526001602052604081206102a690610751565b60008281526020819052604090206001015461061c816106f4565b6104728383610723565b61063082826105c1565b6104f1576000828152602081815260408083206001600160a01b03851684529091529020805460ff191660011790556106663390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000610556836001600160a01b03841661075b565b60006001600160e01b03198216637965db0b60e01b14806102a657506301ffc9a760e01b6001600160e01b03198316146102a6565b6106fe81336107aa565b50565b61070b8282610626565b600082815260016020526040902061047290826106aa565b61072d828261080e565b60008281526001602052604090206104729082610873565b60006105568383610888565b60006102a6825490565b60008181526001830160205260408120546107a257508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610559565b506000610559565b6107b482826105c1565b6104f1576107cc816001600160a01b031660146108c0565b6107d78360206108c0565b6040516020016107e8929190610c94565b60408051601f198184030181529082905262461bcd60e51b82526102d591600401610d09565b61081882826105c1565b156104f1576000828152602081815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b6000610556836001600160a01b038416610aa2565b60008260000182815481106108ad57634e487b7160e01b600052603260045260246000fd5b9060005260206000200154905092915050565b606060006108cf836002610da6565b6108da906002610d8e565b67ffffffffffffffff81111561090057634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f19166020018201604052801561092a576020820181803683370190505b509050600360fc1b8160008151811061095357634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a905350600f60fb1b8160018151811061099057634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a90535060006109b4846002610da6565b6109bf906001610d8e565b90505b6001811115610a53576f181899199a1a9b1b9c1cb0b131b232b360811b85600f1660108110610a0157634e487b7160e01b600052603260045260246000fd5b1a60f81b828281518110610a2557634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a90535060049490941c93610a4c81610e08565b90506109c2565b5083156105565760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e7460448201526064016102d5565b60008181526001830160205260408120548015610bb5576000610ac6600183610dc5565b8554909150600090610ada90600190610dc5565b9050818114610b5b576000866000018281548110610b0857634e487b7160e01b600052603260045260246000fd5b9060005260206000200154905080876000018481548110610b3957634e487b7160e01b600052603260045260246000fd5b6000918252602080832090910192909255918252600188019052604090208390555b8554869080610b7a57634e487b7160e01b600052603160045260246000fd5b600190038181906000526020600020016000905590558560010160008681526020019081526020016000206000905560019350505050610559565b6000915050610559565b80356001600160a01b03811681146102a957600080fd5b600060208284031215610be7578081fd5b61055682610bbf565b600060208284031215610c01578081fd5b5035919050565b60008060408385031215610c1a578081fd5b82359150610c2a60208401610bbf565b90509250929050565b60008060408385031215610c45578182fd5b50508035926020909101359150565b600060208284031215610c65578081fd5b81356001600160e01b031981168114610556578182fd5b600060208284031215610c8d578081fd5b5051919050565b60007f416363657373436f6e74726f6c3a206163636f756e742000000000000000000082528351610ccc816017850160208801610ddc565b7001034b99036b4b9b9b4b733903937b6329607d1b6017918401918201528351610cfd816028840160208801610ddc565b01602801949350505050565b6000602082528251806020840152610d28816040850160208701610ddc565b601f01601f19169190910160400192915050565b60208082526032908201527f4f72626974616c41706573437573746f6d73436f6e74726f6c6c65723a206361604082015271363632b91036bab9ba1031329030b236b4b760711b606082015260800190565b60008219821115610da157610da1610e1f565b500190565b6000816000190483118215151615610dc057610dc0610e1f565b500290565b600082821015610dd757610dd7610e1f565b500390565b60005b83811015610df7578181015183820152602001610ddf565b838111156104475750506000910152565b600081610e1757610e17610e1f565b506000190190565b634e487b7160e01b600052601160045260246000fdfea26469706673582212209473cfd33f71e63c4d87dfa90346ab5373135d6013cdefb672b8a3255047ddb164736f6c63430008030033";
